<script lang="ts" setup>
// Les deux cloches du header : messagerie et notifications. Le composant est
// monté deux fois (barre mobile et barre desktop), chacune gardant son propre
// état d'ouverture — d'où l'absence d'état partagé ici.
interface MailItem {
  id: number
  from: string
  subject: string
  body: string
  time: number
}

interface NotificationItem {
  id: number
  title: string
  time: number
}

// Données de démonstration, en attendant les endpoints correspondants.
const mails: MailItem[] = [
  {
    id: 1,
    from: 'jean13@gmail.com',
    subject: 'Nouveau message',
    body: 'Vous avez reçu un nouveau message de John Doe.',
    time: Date.now(),
  },
  {
    id: 2,
    from: 'nathalie19@hotmail.fr',
    subject: 'Nouveau message',
    body: 'Vous avez reçu un nouveau message de Jane Doe.',
    time: Date.now() - 2 * 60 * 60 * 1000,
  },
]

const notifications: NotificationItem[] = [
  {
    id: 1,
    title: 'Une notification',
    time: Date.now(),
  },
  {
    id: 2,
    title: 'Une autre notification avec un titre plus long',
    time: Date.now() - 4 * 60 * 60 * 1000,
  },
]

const mailIconOpen = ref(true)
const notifIconOpen = ref(true)

function toggleMailIcon() {
  mailIconOpen.value = !mailIconOpen.value
}

function toggleNotifIcon() {
  notifIconOpen.value = !notifIconOpen.value
}
</script>

<template>
  <div class="flex gap-3">
    <UPopover :ui="{ content: 'w-80' }">
      <UButton
        variant="ghost"
        color="neutral"
        :icon="mailIconOpen ? 'i-lucide-mail-open' : 'i-lucide-mail-warning'"
        aria-label="Messagerie"
        class="relative"
        @click="toggleMailIcon"
      />
      <template #content>
        <template v-if="mails.length">
          <div v-for="mail in mails" :key="mail.id" class="p-2">
            <Mail :mail="mail" />
          </div>
        </template>
        <NoNotification v-else />
      </template>
    </UPopover>

    <UPopover :ui="{ content: 'w-80' }">
      <UButton
        variant="ghost"
        color="neutral"
        :icon="notifIconOpen ? 'i-lucide-bell' : 'i-lucide-bell-dot'"
        aria-label="Notifications"
        class="relative"
        @click="toggleNotifIcon"
      />
      <template #content>
        <template v-if="notifications.length">
          <div v-for="notification in notifications" :key="notification.id" class="p-2">
            <Notification :notification="notification" />
          </div>
        </template>
        <NoNotification v-else />
      </template>
    </UPopover>
  </div>
</template>
